import {
  BookWidgetAem,
  BookWidgetFields
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { CatalogApiFieldsValue } from '../../models/core-apis/catalog-api.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { basicFaresFieldCheckedValue } from '../utils/utils.adapter';

export const updateBasicFaresFieldFromRecentSearch = (
  retrieveSearchData: RetrieveSearchData,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  catalogApiFieldsValue: CatalogApiFieldsValue | null,
  bookWidgetAem: BookWidgetAem | null
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (!bookWidgetFieldsMasterConfig.basicFaresField?.hide) {
    let checked = basicFaresFieldCheckedValue(
      catalogApiFieldsValue,
      bookWidgetAem
    );

    if (retrieveSearchData?.includeBasicFaresUnchecked) {
      checked = false;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      basicFaresField: {
        ...updatedBookWidgetFields.basicFaresField,
        checked,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
